import { render, staticRenderFns } from "./createGoods.vue?vue&type=template&id=1965344c&scoped=true"
import script from "./createGoods.vue?vue&type=script&lang=js"
export * from "./createGoods.vue?vue&type=script&lang=js"
import style0 from "./createGoods.vue?vue&type=style&index=0&id=1965344c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1965344c",
  null
  
)

export default component.exports